import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const AttachmentTypeForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {
    const apiObject = 'attachmenttype'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'attachment_type.general.name_label',
            type: 'text',
            placeholder: 'attachment_type.general.name_placeholder',
        }
    ];

    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default AttachmentTypeForm;